/**
 * Sold-out last on collection grids.
 * Boutique collections are sorted in Liquid before pagination.
 * Larger catalogs: page 1 pulls later in-stock cards and never keeps
 * unavailable tiles on the first page. Other product grids only move
 * sold-out cards to the end of the current list.
 */
(function () {
  const MAX_FETCH_PAGES = 40;

  function itemKey(li) {
    const link = li.querySelector('a[href*="/products/"], a.full-unstyled-link');
    return link ? link.getAttribute('href') : '';
  }

  function isAvailable(li) {
    return li.getAttribute('data-available') !== 'false';
  }

  function moveSoldOutToEnd(grid) {
    Array.from(grid.querySelectorAll(':scope > li[data-available="false"]')).forEach((li) => {
      grid.appendChild(li);
    });
  }

  function currentQuery() {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('lace_page');
    params.delete('section_id');
    return params;
  }

  async function fillPage1(grid) {
    if (grid.dataset.laceFullSort === 'true') return;
    const page = Number(grid.dataset.lacePage || 1);
    if (page !== 1) {
      moveSoldOutToEnd(grid);
      return;
    }
    const soldOnPage = grid.querySelector(':scope > li[data-available="false"]');
    const lastPage = Number(grid.dataset.lacePages || 1);
    if (!soldOnPage || lastPage <= 1) {
      moveSoldOutToEnd(grid);
      return;
    }
    const perPage = Number(grid.dataset.lacePerPage || 16);
    const sectionId = grid.dataset.laceSection;
    if (!sectionId) {
      moveSoldOutToEnd(grid);
      return;
    }
    const inStock = Array.from(grid.querySelectorAll(':scope > li')).filter(isAvailable);
    const seen = new Set(inStock.map(itemKey).filter(Boolean));
    let next = 2;
    let fetched = 0;
    while (inStock.length < perPage && next <= lastPage && fetched < MAX_FETCH_PAGES) {
      const params = currentQuery();
      params.set('section_id', sectionId);
      params.set('page', String(next));
      try {
        const res = await fetch(`${window.location.pathname}?${params.toString()}`);
        if (!res.ok) break;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const remote = doc.getElementById(grid.id) || doc.querySelector('ul.product-grid');
        const items = remote ? Array.from(remote.querySelectorAll(':scope > li')) : [];
        items.forEach((li) => {
          if (!isAvailable(li)) return;
          const key = itemKey(li);
          if (!key || seen.has(key)) return;
          seen.add(key);
          inStock.push(document.importNode(li, true));
        });
        next += 1;
        fetched += 1;
        if (!items.length) break;
      } catch (err) {
        console.warn('lace-soldout-last', err);
        break;
      }
    }
    grid.replaceChildren(...inStock.slice(0, perPage));
  }

  function boot() {
    const grid = document.getElementById('product-grid');
    if (grid && grid.dataset.laceSoldoutLast === 'true') {
      fillPage1(grid);
    }
    document.querySelectorAll('ul.product-grid').forEach((g) => {
      if (g.id === 'product-grid' && g.dataset.laceSoldoutLast === 'true') return;
      moveSoldOutToEnd(g);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('lace:grid-updated', boot);
})();
